<!-- src/components/AddTask.vue -->
<template>
  <li class="flex items-center bg-white shadow rounded">
    <input 
      type="text" 
      v-model="newTaskTitle" 
      @keyup.enter="createTask" 
      class="flex-1 form-input px-4 py-2 border rounded focus:outline-none focus:ring focus:border-blue-300"
      ref="newTaskInput"
    >
    <button @click="createTask" class="btn bg-green-500 text-white px-4 py-3 rounded hover:bg-green-600">Add</button>
  </li>
</template>

<script>
import { ref, onMounted } from 'vue'
import Task from '../models/Task'

export default {
  name: 'AddTask',
  props: {
    fileName: String
  },
  setup(props, { emit }) {
    const newTaskTitle = ref('')
    const newTaskInput = ref(null)


    const createTask = () => {
      const task = new Task({
        title: newTaskTitle.value.trim(),
        file: props.fileName,
        completed: false
      })
      task.create()
      
      emit('taskCreated', task)
      
      // Emit an event to update the task list

      
      // Your create task logic here
    }


    onMounted(() => {
      newTaskInput.value.focus()
    })

    return {
      createTask,
      newTaskTitle,
      newTaskInput
    }
  }

}
</script>

<style scoped>
/* Add your styles here */
</style>